/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreatePostDto } from '../model';
// @ts-ignore
import type { PaginatedPostLikersResponseDto } from '../model';
// @ts-ignore
import type { PaginatedPostsResponseDto } from '../model';
// @ts-ignore
import type { PostDto } from '../model';
// @ts-ignore
import type { ToggleLikeResponseDto } from '../model';
// @ts-ignore
import type { UpdatePostDto } from '../model';
/**
 * PostsApi - axios parameter creator
 * @export
 */
export const PostsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerCreate: async (createPostDto: CreatePostDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPostDto' is not null or undefined
            assertParamExists('postsControllerCreate', 'createPostDto', createPostDto)
            const localVarPath = `/api/posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a post (soft delete)
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerDeletePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postsControllerDeletePost', 'id', id)
            const localVarPath = `/api/posts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all posts with pagination
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of posts per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindAll: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get posts by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postsControllerFindByUser', 'userId', userId)
            const localVarPath = `/api/posts/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single post by ID
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindOne: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postsControllerFindOne', 'id', id)
            const localVarPath = `/api/posts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users who liked a post with pagination
         * @param {string} id Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerGetPostLikers: async (id: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postsControllerGetPostLikers', 'id', id)
            const localVarPath = `/api/posts/{id}/likers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle like on a post
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerToggleLike: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postsControllerToggleLike', 'id', id)
            const localVarPath = `/api/posts/{id}/like`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a post
         * @param {string} id Post ID
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerUpdatePost: async (id: string, updatePostDto: UpdatePostDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postsControllerUpdatePost', 'id', id)
            // verify required parameter 'updatePostDto' is not null or undefined
            assertParamExists('postsControllerUpdatePost', 'updatePostDto', updatePostDto)
            const localVarPath = `/api/posts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostsApi - functional programming interface
 * @export
 */
export const PostsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerCreate(createPostDto: CreatePostDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerCreate(createPostDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a post (soft delete)
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerDeletePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerDeletePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all posts with pagination
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of posts per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerFindAll(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPostsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerFindAll(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get posts by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerFindByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerFindByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single post by ID
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerFindOne(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users who liked a post with pagination
         * @param {string} id Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerGetPostLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPostLikersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerGetPostLikers(id, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerGetPostLikers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle like on a post
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerToggleLike(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleLikeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerToggleLike(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerToggleLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a post
         * @param {string} id Post ID
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postsControllerUpdatePost(id: string, updatePostDto: UpdatePostDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postsControllerUpdatePost(id, updatePostDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostsApi.postsControllerUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PostsApi - factory interface
 * @export
 */
export const PostsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerCreate(createPostDto: CreatePostDto, options?: RawAxiosRequestConfig): AxiosPromise<PostDto> {
            return localVarFp.postsControllerCreate(createPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a post (soft delete)
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerDeletePost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postsControllerDeletePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all posts with pagination
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of posts per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindAll(page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPostsResponseDto> {
            return localVarFp.postsControllerFindAll(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get posts by user ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PostDto>> {
            return localVarFp.postsControllerFindByUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single post by ID
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerFindOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PostDto> {
            return localVarFp.postsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users who liked a post with pagination
         * @param {string} id Post ID
         * @param {number} [page] Page number (starts from 1)
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerGetPostLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPostLikersResponseDto> {
            return localVarFp.postsControllerGetPostLikers(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle like on a post
         * @param {string} id Post ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerToggleLike(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ToggleLikeResponseDto> {
            return localVarFp.postsControllerToggleLike(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a post
         * @param {string} id Post ID
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postsControllerUpdatePost(id: string, updatePostDto: UpdatePostDto, options?: RawAxiosRequestConfig): AxiosPromise<PostDto> {
            return localVarFp.postsControllerUpdatePost(id, updatePostDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostsApi - object-oriented interface
 * @export
 * @class PostsApi
 * @extends {BaseAPI}
 */
export class PostsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new post
     * @param {CreatePostDto} createPostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerCreate(createPostDto: CreatePostDto, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerCreate(createPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a post (soft delete)
     * @param {string} id Post ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerDeletePost(id: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerDeletePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all posts with pagination
     * @param {number} [page] Page number (starts from 1)
     * @param {number} [limit] Number of posts per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerFindAll(page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerFindAll(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get posts by user ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerFindByUser(userId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerFindByUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single post by ID
     * @param {string} id Post ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerFindOne(id: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users who liked a post with pagination
     * @param {string} id Post ID
     * @param {number} [page] Page number (starts from 1)
     * @param {number} [limit] Number of users per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerGetPostLikers(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerGetPostLikers(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle like on a post
     * @param {string} id Post ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerToggleLike(id: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerToggleLike(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a post
     * @param {string} id Post ID
     * @param {UpdatePostDto} updatePostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public postsControllerUpdatePost(id: string, updatePostDto: UpdatePostDto, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).postsControllerUpdatePost(id, updatePostDto, options).then((request) => request(this.axios, this.basePath));
    }
}

